import React, { useState, useEffect } from 'react';
import {
  Button, Tabs, Tab
} from '@material-ui/core';

import { required, FormDataConsumer, useNotify } from "ra-core";
import { Prompt } from 'react-router';
import { AutocompleteInput, TextInput, ArrayInput, SimpleFormIterator, NumberInput, SelectInput, ReferenceInput } from "ra-ui-materialui";
import {
  SimpleForm,
  Toolbar
} from "react-admin";
import AutoCompleteCustom from "../AutoCompleteCustom";
import { ActivityTypeValueInput } from "../ActivityTypeValueInput";
import CloseIcon from '@material-ui/icons/Close';
import { FormSpy } from 'react-final-form';


const diasSemana = [
  { id: 1, name: 'Lunes' },
  { id: 2, name: 'Martes' },
  { id: 3, name: 'Miércoles' },
  { id: 4, name: 'Jueves' },
  { id: 5, name: 'Viernes' },
  { id: 6, name: 'Sabado' },
  { id: 0, name: 'Domingo' },
];


export const ActivityPlanned = props => {

  const { editingActivity, setEditingActivity, onSave, professionalTypes, identity } = props;

  const [isFormModified, setIsFormModified] = useState(true);
  const [isPromptActive, setIsPromptActive] = useState(true);
  const [professionalForm, setProfessionalForm] = useState();
  const [typeValueForm, setTypeValueForm] = useState();

  
  const [activeTab, setActiveTab] = useState(0);
  const notify = useNotify()
  var filterType = ['SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST'];

  var filterId = professionalTypes?.filter(item => filterType.includes(item.value)).map(item => item.id);


  const handleFormChange = () => {
    setIsFormModified(true);
  };

  const handleSave = async (data) => {

    if (data) {

      if (professionalForm || typeValueForm) {
        const updatedActivity = {
          ...editingActivity,
          professionalName: professionalForm && editingActivity.professionalId !== professionalForm?.professionalId ? professionalForm?.name + professionalForm?.surnames : editingActivity?.professionalName,
          subtypologyName: typeValueForm && editingActivity.secondaryTypeId !== typeValueForm?.secondaryTypeId ? typeValueForm?.value : editingActivity?.subtypologyName,
        };
        onSave(updatedActivity);
      } else {
        onSave(data);
      }

      setIsFormModified(false);
      notify('Elemento guardados', 'info');
    } else {
      console.error("Data is undefined, cannot save.");
    }
  };



  const handleTabChange = (event, newValue) => {

    setIsPromptActive(false);
    setActiveTab(newValue);

    setTimeout(() => {
      if (isFormModified) {
        setIsPromptActive(true);
      }
    }, 1000);
  };

  useEffect(() => {
    if (!editingActivity) {
      setIsFormModified(false);
      setIsPromptActive(false);
    }
  }, [editingActivity]);


  const CustomSaveButton = ({ onClick }) => (
    <FormSpy>
      {({ form, values }) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => onClick(values)}
          startIcon={<CloseIcon />}
        >
          Guardar
        </Button>
      )}
    </FormSpy>
  );
  return (

    <>
      <Prompt
        when={isPromptActive}
        message="Las propuestas de actividades programadas se perderán. ¿Seguro que quieres salir?"
      />


      <Tabs value={activeTab} onChange={handleTabChange} aria-label="Formulario de actividades">
        <Tab label="Datos Generales" />
        <Tab label="Contratos" />
        <Tab label="Participantes" />
      </Tabs>



      {activeTab === 0 && (

        <SimpleForm style={{ width: '100%' }} record={editingActivity}
          onChange={handleFormChange} toolbar={
            <Toolbar style={{ backgroundColor: 'white' }}>
              <div >
                <CustomSaveButton onClick={(e) => {
                  handleSave(e);
                }} />


                <Button style={{ marginLeft: "2rem" }} color="red"
                  variant="outlined"
                  onClick={() => setEditingActivity(null)}>Cancelar</Button>
              </div>


            </Toolbar>
          }>
          <div className="grid-editar-planned">
            <TextInput label="Nombre" source="name" fullWidth />
            <TextInput label="Descripción" source="description" fullWidth />

            <SelectInput
              label="Día"
              source="day"
              choices={diasSemana}
              fullWidth
            />

            <div className="new-line-custom">
              <TextInput
                label="Hora Inicio"
                source="startTime"
                type="time"
                format={value => value?.slice(0, 5)}
                parse={value => value}
                fullWidth
              />
              <NumberInput label="Duración (h)" source="duration" fullWidth />
            </div>

            <ReferenceInput
              label="Responsable"
              source="professionalId"
              reference="professional"
              filter={{ type: ['SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST'] }}
              filterToQuery={(value) => {
                return { nameINumber: value, professionalTypeId: filterId }
              }}
              fullWidth
            >
              <AutocompleteInput
                onSelect={(event) => { setProfessionalForm(event) }}
                optionText={(record) => record?.identificationNumber + ' - ' + record?.name + ' ' + record?.surnames} resettable={true} />
            </ReferenceInput>
            <ActivityTypeValueInput
              source="secondaryTypeId"
              type="plannedActivity"
              setTypeValueForm={setTypeValueForm}
              isDisabled={false}
            />
          </div>

        </SimpleForm>
      )}

      {activeTab === 1 && (
        <SimpleForm record={editingActivity} toolbar={
          <Toolbar style={{ backgroundColor: 'white' }}>
            <div >
              <CustomSaveButton onClick={(e) => {
                handleSave(e);
              }} />


              <Button style={{ marginLeft: "2rem" }} color="red"
                variant="outlined"
                onClick={() => setEditingActivity(null)}>Cancelar</Button>
            </div>


          </Toolbar>
        }>
          <ArrayInput label="Contratos" source="contracts" id="arrayCustomContracts" validate={[required()]} disabled={false}>
            <SimpleFormIterator disableRemove={false}>
              <FormDataConsumer>
                {({ scopedFormData, getSource }) => {

                  const source = getSource('');
                  const indexMatch = source.match(/\[(\d+)\]/);

                  const index = indexMatch ? indexMatch[1] : null;

                  return (
                    <div>
                      <AutoCompleteCustom
                        type={"CONTRACTS"}
                        label={"Contrato"}
                        placeholder={"Buscar contrato"}
                        disabled={false}
                        data={scopedFormData}
                        index={index}
                        requiredInput={true}
                        {...props} />


                    </div>
                  );
                }}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </SimpleForm>
      )}

      {activeTab === 2 && (
        <SimpleForm record={editingActivity} toolbar={
          <Toolbar style={{ backgroundColor: 'white' }}>
            <div >
              <CustomSaveButton onClick={(e) => {
                handleSave(e);
              }} />
              <Button style={{ marginLeft: "2rem" }} color="red"
                variant="outlined"
                onClick={() => setEditingActivity(null)}>Cancelar</Button>
            </div>
          </Toolbar>
        }>

          <ArrayInput label="Participantes" source="participants" validate={[required()]}>
            <SimpleFormIterator disableRemove={false} disableAdd={false}>
              <FormDataConsumer>
                {({ scopedFormData, getSource }) => {
                  // Extraemos el índice a partir del source
                  const source = getSource('');
                  const indexMatch = source.match(/\[(\d+)\]/); // Captura el número entre corchetes

                  const index = indexMatch ? indexMatch[1] : null; // Obtenemos el índice o null si no se encuentra
                  return (
                    <div>
                      <AutoCompleteCustom
                        type={"PARTICIPANT"}
                        label={"Usuario"}
                        placeholder={"Buscar participante"}
                        disabled={false}
                        data={scopedFormData}
                        index={index}
                        requiredInput={true}
                        identity={identity}
                        //filterIds={values?.contracts?.map(e => e?.id)}
                        {...props} />

                    </div>
                  );
                }}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </SimpleForm>
      )}

    </>

  );
};


export default ActivityPlanned;